export const NAVIGATION_DRAWER_WIDTH = 240
